module.exports = __webpack_public_path__ + "static/media/72.4233b61c.webp";